import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';
import { parseNabidkaWizardSearch } from '@/modules/ojeta-vozidla/wizard-helpers';

const NabidkaWizard = lazy(() =>
  import('@/modules/ojeta-vozidla/NabidkaWizard').then((m) => ({ default: m.NabidkaWizard })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/nabidky/wizard',
  component: () => (
    <Suspense fallback={null}>
      <NabidkaWizard />
    </Suspense>
  ),
  validateSearch: parseNabidkaWizardSearch,
});
